import React from "react";
import Dropdown from "../DropDown";

interface SummaryTypeDropdownProps {
  selectedSummaryType: string;
  onSummaryTypeChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const SummaryTypeDropdown: React.FC<SummaryTypeDropdownProps> = ({
  selectedSummaryType,
  onSummaryTypeChange,
  disabled = false,
  className = "",
  onFocus,
}) => {
  const options = [
    { value: "INTERPOLATED", label: "INTERPOLATED" },
    { value: "SAMPLED", label: "SAMPLED" },
    { value: "SUMMARIZED", label: "SUMMARIZED" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedSummaryType}
      onValueChange={onSummaryTypeChange}
      disabled={disabled}
      className={className}
      placeholder="Select Summary Type"
      onFocus={onFocus}
    />
  );
};

export default SummaryTypeDropdown;
